import { render, staticRenderFns } from "./NewStarDialog.vue?vue&type=template&id=5b9e40c5&"
import script from "./NewStarDialog.vue?vue&type=script&lang=js&"
export * from "./NewStarDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports